(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_PREFIX = 'announcement-dismissed-';
    const REFLOW_EVENT = 'sticky-header:reflow';
    const ANIMATING_CLASS = 'announcement-bar-animating';
    const bars = document.querySelectorAll('[data-announcement-bar]');
    if (!bars.length) return;

    const getScrollY = () =>
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const reflowHeader = () => {
      window.dispatchEvent(new CustomEvent(REFLOW_EVENT));
    };

    let scrollIgnoreUntil = 0;

    const isScrollControlLocked = () =>
      document.documentElement.classList.contains(ANIMATING_CLASS) ||
      Date.now() < scrollIgnoreUntil;

    const compensateScroll = (heightDelta) => {
      if (!heightDelta) return;
      scrollIgnoreUntil = Date.now() + 200;
      const nextY = Math.max(0, getScrollY() + heightDelta);
      window.scrollTo({ top: nextY, left: 0, behavior: 'auto' });
    };

    const getShell = (bar) => bar.closest('[data-announcement-shell]');

    const measureShell = (shell) => {
      if (!shell || shell.classList.contains('announcement-bar-shell--collapsed')) return 0;

      const height = shell.scrollHeight;
      if (height > 0) {
        shell.dataset.naturalHeight = String(height);
      }

      return height;
    };

    const setShellCollapsed = (shell, collapsed, { animate = true, compensate = false } = {}) => {
      if (!shell) return false;

      const isCollapsed = shell.classList.contains('announcement-bar-shell--collapsed');
      if (isCollapsed === collapsed) return false;

      let naturalHeight = Number.parseInt(shell.dataset.naturalHeight, 10);
      if (!naturalHeight) {
        naturalHeight = measureShell(shell) || shell.offsetHeight;
      }

      if (compensate && naturalHeight > 0 && getScrollY() > naturalHeight) {
        compensateScroll(collapsed ? naturalHeight : -naturalHeight);
      }

      if (!animate) {
        shell.classList.add('announcement-bar-shell--no-transition');
      }

      shell.classList.toggle('announcement-bar-shell--collapsed', collapsed);
      shell.setAttribute('aria-hidden', collapsed ? 'true' : 'false');

      const finish = () => {
        shell.classList.remove('announcement-bar-shell--no-transition');
        document.documentElement.classList.remove(ANIMATING_CLASS);
        scrollIgnoreUntil = Date.now() + 200;
        reflowHeader();
      };

      if (!animate) {
        finish();
        return true;
      }

      document.documentElement.classList.add(ANIMATING_CLASS);

      let finished = false;
      const onEnd = (event) => {
        if (finished || event.target !== shell) return;
        finished = true;
        shell.removeEventListener('transitionend', onEnd);
        finish();
      };

      shell.addEventListener('transitionend', onEnd);
      window.setTimeout(() => {
        if (!finished) onEnd({ target: shell });
      }, 350);

      return true;
    };

    const hideBar = (bar, { animate = true } = {}) => {
      const shell = getShell(bar);

      bar.classList.add('announcement-bar--dismissed');
      bar.setAttribute('aria-hidden', 'true');
      setShellCollapsed(shell, true, { animate, compensate: true });
    };

    const isDismissed = (bar) => {
      const id = bar.dataset.announcementId;
      if (!id) return false;

      const mode = bar.dataset.dismissMode || 'session';
      try {
        if (mode === 'permanent') {
          return localStorage.getItem(`${STORAGE_PREFIX}${id}`) === '1';
        }
        return sessionStorage.getItem(`${STORAGE_PREFIX}${id}`) === '1';
      } catch (_error) {
        return false;
      }
    };

    const persistDismiss = (bar) => {
      const id = bar.dataset.announcementId;
      if (!id) return;

      const mode = bar.dataset.dismissMode || 'session';
      try {
        if (mode === 'permanent') {
          localStorage.setItem(`${STORAGE_PREFIX}${id}`, '1');
        } else {
          sessionStorage.setItem(`${STORAGE_PREFIX}${id}`, '1');
        }
      } catch (_error) {
        return;
      }
    };

    const shells = [...new Set([...bars].map(getShell).filter(Boolean))];
    shells.forEach(measureShell);

    bars.forEach((bar) => {
      if (bar.hasAttribute('hidden')) return;

      if (bar.dataset.dismissible === 'true' && isDismissed(bar)) {
        hideBar(bar, { animate: false });
        return;
      }

      const dismissButton = bar.querySelector('[data-announcement-dismiss]');
      if (dismissButton) {
        dismissButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          persistDismiss(bar);
          hideBar(bar, { animate: true });
        });
      }
    });

    const scrollShells = [...bars]
      .filter(
        (bar) =>
          bar.dataset.hideOnScroll === 'true' &&
          bar.closest('#sticky-header') &&
          !bar.classList.contains('announcement-bar--dismissed')
      )
      .map((bar) => getShell(bar))
      .filter(Boolean);

    if (!scrollShells.length) return;

    let lastScrollY = getScrollY();
    let ticking = false;
    let scrollState = 'visible';
    let hiddenAtScrollY = 0;
    let toggleCooldownUntil = 0;

    const showAtTop = 24;
    const hideAfterOffset = 120;
    const minHideDelta = 12;
    const minShowDelta = 14;
    const showUpDistance = 96;
    const toggleCooldownMs = 500;

    const applyScrollState = (nextState) => {
      if (nextState === scrollState) return;

      const collapsed = nextState === 'hidden';
      let changed = false;

      scrollShells.forEach((shell) => {
        if (setShellCollapsed(shell, collapsed, { animate: true, compensate: false })) {
          changed = true;
        }
      });

      if (!changed) return;

      scrollState = nextState;
      toggleCooldownUntil = Date.now() + toggleCooldownMs;

      if (collapsed) {
        hiddenAtScrollY = getScrollY();
      }
    };

    const updateScrollState = () => {
      ticking = false;

      if (isScrollControlLocked() || Date.now() < toggleCooldownUntil) {
        return;
      }

      const currentScrollY = getScrollY();
      const delta = currentScrollY - lastScrollY;

      if (currentScrollY <= showAtTop) {
        applyScrollState('visible');
      } else if (scrollState === 'visible') {
        if (currentScrollY > hideAfterOffset && delta >= minHideDelta) {
          applyScrollState('hidden');
        }
      } else if (delta <= -minShowDelta) {
        const scrolledUpFromHide = hiddenAtScrollY - currentScrollY;
        if (scrolledUpFromHide >= showUpDistance) {
          applyScrollState('visible');
        }
      }

      if (Math.abs(delta) >= 2) {
        lastScrollY = currentScrollY;
      }
    };

    if (getScrollY() > hideAfterOffset) {
      scrollState = 'hidden';
      hiddenAtScrollY = getScrollY();
      scrollShells.forEach((shell) => {
        setShellCollapsed(shell, true, { animate: false, compensate: false });
      });
    } else {
      reflowHeader();
    }

    window.addEventListener(
      'scroll',
      () => {
        if (ticking || isScrollControlLocked()) return;
        ticking = true;
        window.requestAnimationFrame(updateScrollState);
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_PREFIX = 'modal-dismissed-';

    const ModalStack = {
      openModals: [],
      backdrop: null,
      scrollY: 0,
      escapeHandler: null,

      getBackdrop() {
        if (!this.backdrop) {
          this.backdrop = document.createElement('div');
          this.backdrop.className = 'announcement-modal-stack__backdrop';
          this.backdrop.addEventListener('click', () => {
            const top = this.openModals[this.openModals.length - 1];
            if (top?.closeOnBackdrop) {
              top.close();
            }
          });
          document.body.appendChild(this.backdrop);
        }
        return this.backdrop;
      },

      lockScroll() {
        if (this.openModals.length !== 1) return;
        this.scrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add('announcement-modal-scroll-lock');
        document.body.style.top = `-${this.scrollY}px`;
      },

      unlockScroll() {
        if (this.openModals.length > 0) return;
        document.documentElement.classList.remove('announcement-modal-scroll-lock');
        document.body.style.top = '';
        window.scrollTo({ top: this.scrollY, left: 0, behavior: 'auto' });
      },

      bindEscape() {
        if (this.escapeHandler) return;
        this.escapeHandler = (event) => {
          if (event.key !== 'Escape') return;
          const top = this.openModals[this.openModals.length - 1];
          if (!top?.closeOnEscape) return;
          event.preventDefault();
          top.close();
        };
        document.addEventListener('keydown', this.escapeHandler);
      },

      unbindEscape() {
        if (!this.escapeHandler || this.openModals.length > 0) return;
        document.removeEventListener('keydown', this.escapeHandler);
        this.escapeHandler = null;
      },

      push(modal) {
        this.openModals.push(modal);
        const backdrop = this.getBackdrop();
        const layer = 1000 + this.openModals.length * 2;
        backdrop.style.zIndex = String(layer - 1);
        modal.dialog.style.zIndex = String(layer);
        backdrop.classList.add('is-visible');
        this.lockScroll();
        this.bindEscape();
      },

      pop(modal) {
        this.openModals = this.openModals.filter((entry) => entry !== modal);
        if (!this.openModals.length) {
          this.backdrop?.classList.remove('is-visible');
          this.unlockScroll();
          this.unbindEscape();
          return;
        }

        const top = this.openModals[this.openModals.length - 1];
        const layer = 1000 + this.openModals.length * 2;
        this.backdrop.style.zIndex = String(layer - 1);
        top.dialog.style.zIndex = String(layer);
      },

      isOpen(modal) {
        return this.openModals.includes(modal);
      },
    };

    class AnnouncementModal extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.dialog = this.querySelector('.announcement-modal__dialog');
        this.panel = this.querySelector('.announcement-modal__panel');
        this.closeButton = this.querySelector('[data-modal-close]');
        this.isClosing = false;
        this.openTimer = null;
        this.isOpen = false;

        this.modalId = this.dataset.modalId || '';
        this.dismissMode = this.dataset.dismissMode || 'session';
        this.dismissDays = Number.parseInt(this.dataset.dismissDays, 10) || 7;
        this.delaySeconds = Number.parseInt(this.dataset.delaySeconds, 10) || 0;
        this.closeOnBackdrop = this.dataset.closeOnBackdrop !== 'false';
        this.closeOnEscape = this.dataset.closeOnEscape !== 'false';
        this.openAutomatically = this.dataset.openAutomatically === 'true';
        this.designMode = this.dataset.designMode === 'true';
        this.hideInEditor = this.dataset.hideInEditor === 'true';
        this.sectionId = this.dataset.sectionId || '';
        this.editorPreviewActive = false;

        this.bindEvents();

        if (this.designMode) {
          if (this.hideInEditor) {
            this.bindEditorEvents();
          } else {
            this.open({ animate: false });
          }
          return;
        }

        this.scheduleInitialOpen();
      }

      scheduleInitialOpen() {
        const run = () => {
          if (this.openForNewsletterFeedback()) {
            return;
          }

          if (this.dataset.initiallyDismissed === 'true') {
            return;
          }

          if (!this.openAutomatically) {
            return;
          }

          if (this.delaySeconds > 0) {
            this.openTimer = window.setTimeout(() => this.open(), this.delaySeconds * 1000);
          } else {
            this.open();
          }
        };

        if (document.querySelector('.newsletter-form')) {
          if (window.__newsletterFeedbackRouted) {
            run();
            return;
          }

          document.addEventListener('newsletter:feedback-routed', run, { once: true });
          return;
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', run, { once: true });
        } else {
          run();
        }
      }

      disconnectedCallback() {
        if (this.openTimer) {
          window.clearTimeout(this.openTimer);
        }
        this.unbindEditorEvents();
        if (this.isOpen) {
          ModalStack.pop(this);
          this.isOpen = false;
        }
      }

      setEditorPreview(active) {
        this.editorPreviewActive = active;
        this.classList.toggle('announcement-modal--editor-hidden', this.hideInEditor && !active);
        this.classList.toggle('announcement-modal--editor-preview', active);
      }

      openEditorPreview() {
        this.setEditorPreview(true);
        this.open({ animate: false });
      }

      closeEditorPreview() {
        this.setEditorPreview(false);
        if (this.isOpen) {
          this.close({ persist: false, animate: false });
        }
      }

      isEditorTarget(detail) {
        if (!detail || !this.sectionId) return false;
        return String(detail.sectionId) === String(this.sectionId);
      }

      bindEditorEvents() {
        if (!this.designMode || !this.hideInEditor || !this.sectionId) return;

        this.onSectionSelect = (event) => {
          if (!this.isEditorTarget(event.detail)) return;
          this.openEditorPreview();
        };

        this.onBlockSelect = (event) => {
          if (!this.isEditorTarget(event.detail)) return;
          this.openEditorPreview();
        };

        this.onSectionDeselect = (event) => {
          if (!this.isEditorTarget(event.detail)) return;
          this.closeEditorPreview();
        };

        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      unbindEditorEvents() {
        if (this.onSectionSelect) {
          document.removeEventListener('shopify:section:select', this.onSectionSelect);
        }
        if (this.onSectionDeselect) {
          document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        }
        if (this.onBlockSelect) {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      getStorageKey() {
        return `${STORAGE_PREFIX}${this.modalId}`;
      }

      openForNewsletterFeedback() {
        const hashId = window.location.hash.replace(/^#/, '');
        const hashForm = hashId ? document.getElementById(hashId) : null;
        const feedbackForm =
          this.querySelector('.newsletter-form--modal.newsletter-form--has-feedback') ||
          (hashForm?.classList.contains('newsletter-form--modal') ? hashForm : null);
        const feedback = feedbackForm?.querySelector(
          '[data-newsletter-success]:not([hidden]), [data-newsletter-errors]:not([hidden])'
        );

        if (!feedbackForm || !feedback) return false;

        if (this.openTimer) {
          window.clearTimeout(this.openTimer);
          this.openTimer = null;
        }

        this.open();
        window.requestAnimationFrame(() => {
          feedback.focus();
        });

        return true;
      }

      persistDismiss() {
        if (!this.modalId || this.designMode) return;

        const key = this.getStorageKey();

        try {
          if (this.dismissMode === 'permanent' || this.dismissMode === 'days') {
            if (this.dismissMode === 'days') {
              const until = Date.now() + this.dismissDays * 86400000;
              localStorage.setItem(key, JSON.stringify({ until }));
            } else {
              localStorage.setItem(key, '1');
            }
            sessionStorage.setItem(key, '1');
            return;
          }

          sessionStorage.setItem(key, '1');
        } catch (_error) {}
      }

      open({ animate = true } = {}) {
        const dialog = this.dialog;
        if (!dialog || this.isOpen || this.isClosing) return;

        dialog.hidden = false;
        dialog.removeAttribute('hidden');
        dialog.classList.remove('is-closing', 'announcement-modal__dialog--pending');
        ModalStack.push(this);
        this.isOpen = true;

        if (!animate) {
          dialog.classList.add('is-visible');
          return;
        }

        requestAnimationFrame(() => {
          this.panel?.offsetHeight;
          requestAnimationFrame(() => {
            dialog.classList.add('is-visible');
          });
        });
      }

      finishClose() {
        const dialog = this.dialog;
        if (!dialog) return;

        dialog.hidden = true;
        dialog.setAttribute('hidden', '');
        dialog.classList.remove('is-closing', 'is-visible');
        this.isClosing = false;
        this.isOpen = false;
        ModalStack.pop(this);
        this.dispatchEvent(new CustomEvent('announcement-modal:closed', { bubbles: true }));
      }

      close({ persist = true, animate = true } = {}) {
        const dialog = this.dialog;
        const panel = this.panel;
        if (!dialog || !this.isOpen || this.isClosing) return;

        if (persist) {
          this.persistDismiss();
        }

        if (!animate) {
          dialog.classList.remove('is-visible', 'is-closing');
          this.finishClose();
          return;
        }

        this.isClosing = true;
        dialog.classList.remove('is-visible');
        dialog.classList.add('is-closing');

        const onEnd = (event) => {
          if (event.target !== panel) return;
          panel.removeEventListener('transitionend', onEnd);
          this.finishClose();
        };

        panel?.addEventListener('transitionend', onEnd);
        window.setTimeout(() => {
          if (this.isClosing) {
            panel?.removeEventListener('transitionend', onEnd);
            this.finishClose();
          }
        }, 400);
      }

      bindEvents() {
        this.closeButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.designMode && this.hideInEditor) {
            this.closeEditorPreview();
            return;
          }
          this.close();
        });

        this.dialog?.addEventListener('click', (event) => {
          if (!this.closeOnBackdrop) return;
          if (event.target !== this.dialog) return;
          if (this.designMode && this.hideInEditor) {
            this.closeEditorPreview();
            return;
          }
          this.close();
        });

        document.addEventListener('click', (event) => {
          const trigger =
            event.target instanceof Element
              ? event.target.closest('[data-modal-open]')
              : null;
          if (!trigger) return;

          const targetId = trigger.getAttribute('data-modal-open');
          if (!targetId || targetId !== this.modalId) return;

          event.preventDefault();
          if (this.openTimer) {
            window.clearTimeout(this.openTimer);
            this.openTimer = null;
          }
          this.open();
        });
      }
    }

    if (!customElements.get('announcement-modal')) {
      customElements.define('announcement-modal', AnnouncementModal);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    if (window.__cartPageBound) return;
    window.__cartPageBound = true;

    const rootUrl = () => window.Shopify?.routes?.root || '/';
    let refreshRequest = null;

    const parseRecommendationSources = (block) => {
      try {
        return JSON.parse(block.dataset.recommendationSources || '[]');
      } catch {
        return [];
      }
    };

    const pickAnchorProductIds = (sources, maxAnchors = 3) => {
      const byId = new Map();
      sources.forEach(({ id, line_price: linePrice }) => {
        const productId = Number(id);
        if (!productId) return;
        const price = Number(linePrice) || 0;
        const current = byId.get(productId) || 0;
        if (price > current) byId.set(productId, price);
      });
      return [...byId.entries()]
        .sort((a, b) => b[1] - a[1])
        .slice(0, maxAnchors)
        .map(([id]) => id);
    };

    const getRecommendationItemKey = (item) => {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link?.getAttribute('href')) return null;
      try {
        return new URL(link.href, window.location.origin).pathname;
      } catch {
        return link.getAttribute('href');
      }
    };

    const fetchRecommendationSection = async (url) => {
      const response = await fetch(url);
      if (!response.ok) return { items: [], template: null };
      const markup = await response.text();
      const html = document.createElement('div');
      html.innerHTML = markup;
      const template = html.querySelector('.cart-recommendations');
      if (!template) return { items: [], template: null };
      return {
        items: [...template.querySelectorAll('.product-row__item')],
        template,
      };
    };

    const mergeRecommendationItems = (lists, limit) => {
      const merged = [];
      const seen = new Set();
      const maxRounds = Math.max(...lists.map((list) => list.length), 0);
      let fallbackIndex = 0;

      for (let round = 0; round < maxRounds && merged.length < limit; round += 1) {
        for (const list of lists) {
          if (merged.length >= limit) break;
          const item = list[round];
          if (!item) continue;
          const key = getRecommendationItemKey(item) || `__fallback-${fallbackIndex++}`;
          if (seen.has(key)) continue;
          seen.add(key);
          merged.push(item.cloneNode(true));
        }
      }

      return merged;
    };

    const buildRecommendationUrl = (base, sectionId, productId, perSource, intent) => {
      const joiner = base.includes('?') ? '&' : '?';
      return `${base}${joiner}section_id=${encodeURIComponent(sectionId)}&product_id=${productId}&limit=${perSource}&intent=${encodeURIComponent(intent)}`;
    };

    const initRecommendations = () => {
      document.querySelectorAll('.cart-page__recommendations[data-recommendation-sources]').forEach((block) => {
        if (!block.classList.contains('is-loading')) return;

        const anchorIds = pickAnchorProductIds(parseRecommendationSources(block), 3);
        if (!anchorIds.length) {
          block.remove();
          return;
        }

        const sectionId = block.dataset.recommendationSection || 'cart-recommendations';
        const intent = block.dataset.recommendationIntent || 'complementary';
        const limit = Number(block.dataset.recommendationLimit || 8);
        const perSource = Number(block.dataset.recommendationPerSource || 4);
        const base = block.dataset.recommendationBase || `${rootUrl()}recommendations/products`;
        const urls = anchorIds.map((id) => buildRecommendationUrl(base, sectionId, id, perSource, intent));

        Promise.all(urls.map((url) => fetchRecommendationSection(url)))
          .then((results) => {
            const withItems = results.filter((result) => result.items.length > 0);
            if (!withItems.length) {
              block.remove();
              return;
            }

            const merged = mergeRecommendationItems(
              withItems.map((result) => result.items),
              limit
            );
            if (!merged.length) {
              block.remove();
              return;
            }

            const templateResult = withItems.find((result) => result.template?.querySelector('.product-row__track'));
            const template = templateResult?.template;
            const track = template?.querySelector('.product-row__track');
            if (!template || !track) {
              block.remove();
              return;
            }

            track.replaceChildren(...merged);
            block.innerHTML = template.innerHTML;
            block.classList.remove('is-loading');
            window.initProductRowSliders?.(block);
          })
          .catch(() => block.remove());
      });
    };

    const refreshCartSection = async () => {
      const section = document.querySelector('[data-cart-section]');
      if (!section) return;
      if (refreshRequest) return refreshRequest;

      refreshRequest = fetch(`${rootUrl()}?sections=cart`)
        .then((response) => response.json())
        .then((sections) => {
          const html = sections.cart;
          if (!html) return;
          const template = document.createElement('template');
          template.innerHTML = html.trim();
          const nextSection = template.content.querySelector('[data-cart-section]');
          if (nextSection) section.replaceWith(nextSection);
          initRecommendations();
        })
        .catch(() => {})
        .finally(() => {
          refreshRequest = null;
        });

      return refreshRequest;
    };

    const removeLine = async (variantId) => {
      const response = await fetch(`${rootUrl()}cart/change.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 }),
      });
      if (!response.ok) return;
      const cart = await response.json();
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };



    // Obs┼éuga zapisu Paczkomatu dopiero po wyj┼Ťciu z pola (zdarzenie blur)
    document.addEventListener('blur', async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const inputInpost = target.closest('.inpost-locker-input-field');
      if (!inputInpost) return;

      const block = inputInpost.closest('.cart-summary__block');
      const status = block?.querySelector('.inpost-save-status');
      const code = inputInpost.value.trim();

      try {
        const response = await fetch(`${rootUrl()}cart/update.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { Paczkomat: code } })
        });
        if (response.ok && status) {
          status.style.display = 'block';
          setTimeout(() => { status.style.display = 'none'; }, 2000);
        }
      } catch (e) {
        console.error('B┼é─ůd zapisu paczkomatu', e);
      }
    }, true);


    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const removeBtn = target.closest('[data-cart-line-remove]');
      if (removeBtn) {
        event.preventDefault();
        const variantId = removeBtn.dataset.variantId;
        if (!variantId) return;
        removeLine(variantId);
      }
    });

    window.addEventListener('cart:updated', () => {
      if (document.querySelector('[data-cart-section]')) refreshCartSection();
    });

    initRecommendations();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-collection]');
    if (!root) return;

    const products = root.querySelector('[data-collection-products]');
    const layoutButtons = root.querySelectorAll('[data-layout]');
    const sidebar = root.querySelector('[data-collection-sidebar]');
    const backdrop = root.querySelector('[data-collection-filters-backdrop]');
    const openBtn = root.querySelector('[data-collection-filters-open]');
    const closeBtn = root.querySelector('[data-collection-filters-close]');

    const setLayout = (layout) => {
      if (!products) return;
      const next = layout === 'list' ? 'list' : 'grid';
      products.dataset.layout = next;
      layoutButtons.forEach((btn) => {
        const active = btn.dataset.layout === next;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const url = new URL(window.location.href);
      if (next === 'grid') {
        url.searchParams.delete('layout');
      } else {
        url.searchParams.set('layout', next);
      }
      window.history.replaceState({}, '', url);
    };

    const params = new URLSearchParams(window.location.search);
    setLayout(params.get('layout') || 'grid');

    layoutButtons.forEach((btn) => {
      btn.addEventListener('click', () => setLayout(btn.dataset.layout));
    });

    const setFiltersOpen = (open) => {
      if (!sidebar) return;
      sidebar.classList.toggle('is-open', open);
      if (backdrop) {
        backdrop.classList.toggle('is-visible', open);
        backdrop.hidden = !open;
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };

    openBtn?.addEventListener('click', () => setFiltersOpen(true));
    closeBtn?.addEventListener('click', () => setFiltersOpen(false));
    backdrop?.addEventListener('click', () => setFiltersOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setFiltersOpen(false);
    });

    const pageSizeSelect = root.querySelector('[data-collection-page-size]');
    pageSizeSelect?.addEventListener('change', async () => {
      pageSizeSelect.disabled = true;
      const rootUrl = window.Shopify?.routes?.root || '/';
      try {
        await fetch(`${rootUrl}cart/update.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              collection_page_size: pageSizeSelect.value,
            },
          }),
        });
      } catch (error) {
        pageSizeSelect.disabled = false;
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-slider-section]").forEach((slider) => {
      const track = slider.querySelector("[data-slider-track]");
      const slides = slider.querySelectorAll(".custom-hero-slide");
      const nextBtn = slider.querySelector("[data-slider-next]");
      const prevBtn = slider.querySelector("[data-slider-prev]");
      const dots = slider.querySelectorAll("[data-slide-dot], [data-slider-dots] button");
      
      if (!track || slides.length <= 1) return;

      let currentIndex = 0;
      const totalSlides = slides.length;
      let interval = setInterval(nextSlide, 5000);

      function updateSlider() {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        dots.forEach((dot, idx) => {
          dot.classList.toggle("is-active", idx === currentIndex);
        });
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      }

      function prevSlide() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlider();
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          nextSlide();
          resetTimer();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          prevSlide();
          resetTimer();
        });
      }

      dots.forEach((dot, idx) => {
        dot.addEventListener("click", () => {
          currentIndex = idx;
          updateSlider();
          resetTimer();
        });
      });

      function resetTimer() {
        clearInterval(interval);
        interval = setInterval(nextSlide, 5000);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // 1. Otwieranie szuflady po kliknięciu w ikonę koszyka
    window.addEventListener('click', (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble, [data-cart-drawer-toggle]');
      if (!cartLink) return;

      // Jeśli jesteśmy już na pełnej podstronie koszyka, nie otwieramy bocznej szuflady
      if (window.location.pathname.endsWith('/cart') || window.location.pathname.endsWith('/cart/')) {
        return;
      }

      const drawer = document.querySelector('side-drawer[data-drawer="cart"]') || document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
      if (drawer) {
        event.preventDefault();
        event.stopImmediatePropagation();
        
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.setAttribute('open', '');
          drawer.classList.add('is-open', 'active');
        }
        
        document.body.classList.add('cart-drawer-open', 'overflow-hidden');
      }
    }, true);

    // 2. Solidne przechwytywanie formularzy "Dodaj do koszyka" (Ajax Cart Interceptor)
    document.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!form.matches('form[action*="/cart/add"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const formData = new FormData(form);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          // Pobieramy odświeżony HTML szuflady oraz sekcję licznika z Shopify
          const sectionsResponse = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
          const sectionsData = await sectionsResponse.json();

          // Aktualizujemy zawartość szuflady w DOM
          if (sectionsData['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
            const newInner = doc.querySelector('[data-cart-drawer-inner]') || doc.querySelector('cart-drawer') || doc.getElementById('CartDrawer');
            const currentInner = document.querySelector('side-drawer[data-drawer="cart"] [data-cart-drawer-inner]') || document.querySelector('[data-cart-drawer-inner]');
            if (newInner && currentInner) {
              currentInner.innerHTML = newInner.innerHTML;
            }
          }

          // Aktualizujemy bąbelek z licznikiem produktów w nagłówku
          if (sectionsData['cart-icon-bubble']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
            const newBubble = doc.getElementById('cart-icon-bubble');
            const currentBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && currentBubble) {
              currentBubble.innerHTML = newBubble.innerHTML;
            }
          }

          // Otwieramy szufladę
          const drawer = document.querySelector('side-drawer[data-drawer="cart"]') || document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
          if (drawer) {
            if (typeof drawer.open === 'function') {
              drawer.open();
            } else {
              drawer.setAttribute('open', '');
              drawer.classList.add('is-open', 'active');
            }
            document.body.classList.add('cart-drawer-open', 'overflow-hidden');
          }
        } else {
          form.submit();
        }
      } catch (e) {
        form.submit();
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  // =============================================================================
  // HERO FLOAT SIZE — developer toggle
  // false (default): freeze --hero-ref-w/h updates on the active slide only while
  //   entry animations are running; updates resume once the longest layer finishes.
  // true: allow live ref-size updates even during entry animations.
  // =============================================================================
  const HERO_FLOAT_REF_UPDATE_DURING_ENTRY = false;

  const HERO_ENTRY_ANIMATION_TYPES = [
    'fade',
    'fade-scale',
    'slide-up',
    'slide-down',
    'slide-left',
    'slide-right',
    'text-reveal',
  ];

  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.hero-slider__viewport');
      this.track = this.querySelector('.hero-slider__track');
      this.slides = Array.from(this.querySelectorAll('.hero-slide'));
      this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
      this.nextBtn = this.querySelector('.hero-slider__arrow--next');
      this.dotsContainer = this.querySelector('.hero-slider__dots');
      this.currentIndex = 0;
      this.autoplayTimer = null;
      this._entryFreezeTimers = new Map();
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
      this.slideStorageKey = this.getSlideStorageKey();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.editorNoAnimations = this.classList.contains('hero-slider--editor-no-animations');
      this.onBlockSelect = null;
      this.onResize = () => {
        this.syncSlideWidths();
        this.updateTransform(false);
        this.slides.forEach((slide) => {
          if (this.canUpdateContentRef(slide)) {
            this.measureContentRef(slide);
          }
        });
      };

      if (this.slides.length === 0) return;

      this.measureHeader();
      this.setupArrowsMobile();
      this.setupDots();
      this.bindEvents();
      this.setupContentRefObserver();
      this.setupEditorEvents();

      const initialIndex = this.designMode ? this.getSavedSlideIndex() : 0;

      requestAnimationFrame(() => {
        this.syncSlideWidths();
        this.slides.forEach((slide, i) => {
          if (i !== initialIndex) {
            this.measureContentRef(slide);
          }
        });
        this.goTo(initialIndex, false);
        this.classList.add('is-initialized');
      });

      if (this.reducedMotion) {
        this.classList.add('is-reduced-motion');
        this.slides.forEach((slide) => slide.classList.add('is-active'));
      } else {
        if (this.autoplayEnabled) {
          this.startAutoplay();
        }
        this.setupIntersectionObserver();
      }

      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      this.saveActiveSlideIndex();
      this.stopAutoplay();
      window.removeEventListener('resize', this.onResize);
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.onBlockSelect = null;
      }
      if (this.observer) this.observer.disconnect();
      if (this.refObserver) this.refObserver.disconnect();
      this.slides.forEach((slide) => this.clearEntryFreeze(slide));
      this._entryFreezeTimers.clear();
    }

    refreshSlides() {
      this.slides = Array.from(this.querySelectorAll('.hero-slide'));
    }

    getSlideBlockId(slide) {
      if (!slide?.id) return null;
      const prefix = 'shopify-block-';
      return slide.id.startsWith(prefix) ? slide.id.slice(prefix.length) : slide.id;
    }

    findSlideFromEditorEvent(event) {
      const target = event.target;
      if (!target || !this.contains(target)) return null;

      const fromAncestor = target.closest('.hero-slide');
      if (fromAncestor) return fromAncestor;

      const trackSlot = target.closest('.hero-slider__track > *');
      if (trackSlot) {
        const slideInSlot = trackSlot.querySelector('.hero-slide');
        if (slideInSlot) return slideInSlot;
      }

      const blockId = event.detail?.blockId;
      if (blockId) {
        const slideById = this.slides.find((slide) => this.getSlideBlockId(slide) === blockId);
        if (slideById) return slideById;

        const blockEl = this.querySelector(`#shopify-block-${blockId}`);
        if (blockEl) {
          const slide = blockEl.closest('.hero-slide');
          if (slide) return slide;
        }
      }

      return null;
    }

    setupEditorEvents() {
      if (!this.designMode) return;

      this.onBlockSelect = (event) => {
        const slide = this.findSlideFromEditorEvent(event);
        if (!slide) return;

        const activateSlide = () => {
          this.refreshSlides();
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.goTo(index, false);
        };

        if (event.detail?.load) {
          requestAnimationFrame(activateSlide);
        } else {
          activateSlide();
        }
      };

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    parseDurationMs(value) {
      if (!value) return 0;

      const trimmed = String(value).trim();
      if (trimmed.endsWith('ms')) return parseFloat(trimmed) || 0;
      if (trimmed.endsWith('s')) return (parseFloat(trimmed) || 0) * 1000;
      return parseFloat(trimmed) || 0;
    }

    getSlideEntryAnimationEndMs(slide) {
      const styles = getComputedStyle(this);
      const stageStep = this.parseDurationMs(styles.getPropertyValue('--hero-stage-step')) || 300;
      const entryFast = this.parseDurationMs(styles.getPropertyValue('--hero-entry-fast')) || 300;
      const entryMedium = this.parseDurationMs(styles.getPropertyValue('--hero-entry-medium')) || 1000;
      const entrySlow = this.parseDurationMs(styles.getPropertyValue('--hero-entry-slow')) || 1200;
      const entryDurations = {
        fade: entryFast,
        'fade-scale': entryMedium,
        'slide-up': entrySlow,
        'slide-down': entrySlow,
        'slide-left': entryMedium,
        'slide-right': entryMedium,
        'text-reveal': entryMedium,
      };

      let maxEnd = 0;

      slide.querySelectorAll('.hero-layer').forEach((layer) => {
        if (layer.classList.contains('hero-slide__bg')) return;

        const animationName = HERO_ENTRY_ANIMATION_TYPES.find((name) =>
          layer.classList.contains(`hero-layer--${name}`)
        );
        if (!animationName) return;

        const stage = parseInt(layer.dataset.entryStage, 10);
        const entryStage = Number.isFinite(stage) ? stage : 1;
        const duration = entryDurations[animationName];
        if (!duration) return;

        const delay = (entryStage - 1) * stageStep;
        maxEnd = Math.max(maxEnd, delay + duration);
      });

      return maxEnd;
    }

    canUpdateContentRef(slide) {
      if (HERO_FLOAT_REF_UPDATE_DURING_ENTRY) return true;
      if (this.reducedMotion || this.editorNoAnimations) return true;
      if (!slide.classList.contains('is-active')) return true;
      return slide.dataset.heroRefEntryFrozen !== 'true';
    }

    clearEntryFreeze(slide) {
      const timer = this._entryFreezeTimers.get(slide);
      if (timer) {
        window.clearTimeout(timer);
        this._entryFreezeTimers.delete(slide);
      }

      slide.dataset.heroRefEntryFrozen = 'false';
    }

    scheduleEntryFreezeClear(slide) {
      this.clearEntryFreeze(slide);

      if (HERO_FLOAT_REF_UPDATE_DURING_ENTRY || this.reducedMotion || this.editorNoAnimations) {
        return;
      }

      const endMs = this.getSlideEntryAnimationEndMs(slide);
      if (endMs <= 0) return;

      slide.dataset.heroRefEntryFrozen = 'true';
      const timer = window.setTimeout(() => {
        slide.dataset.heroRefEntryFrozen = 'false';
        this._entryFreezeTimers.delete(slide);
      }, endMs);
      this._entryFreezeTimers.set(slide, timer);
    }

    measureContentRef(slide) {
      const ref = slide?.querySelector('.hero-slide__content-ref');
      if (!ref) return;

      const { width, height } = ref.getBoundingClientRect();
      if (width <= 0 || height <= 0) return;

      slide.style.setProperty('--hero-ref-w', `${width}px`);
      slide.style.setProperty('--hero-ref-h', `${height}px`);
    }

    setupContentRefObserver() {
      if (!('ResizeObserver' in window)) return;

      this.refObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const slide = entry.target.closest('.hero-slide');
          if (!slide || !this.canUpdateContentRef(slide)) return;
          this.measureContentRef(slide);
        });
      });

      this.slides.forEach((slide) => {
        const ref = slide.querySelector('.hero-slide__content-ref');
        if (ref) this.refObserver.observe(ref);
      });
    }

    getSlideStorageKey() {
      const section = this.closest('.shopify-section');
      if (!section || !section.id) return null;
      return `hero-slider-active:${section.id}`;
    }

    getSavedSlideIndex() {
      if (!this.slideStorageKey) return 0;

      try {
        const saved = sessionStorage.getItem(this.slideStorageKey);
        if (!saved) return 0;

        let data;
        try {
          data = JSON.parse(saved);
        } catch (_parseError) {
          const legacyIndex = parseInt(saved, 10);
          if (Number.isFinite(legacyIndex) && legacyIndex >= 0 && legacyIndex < this.slides.length) {
            return legacyIndex;
          }
          return 0;
        }

        if (data.blockId) {
          const indexByBlockId = this.slides.findIndex(
            (slide) => this.getSlideBlockId(slide) === data.blockId
          );
          if (indexByBlockId >= 0) return indexByBlockId;
        }

        const index = parseInt(data.index, 10);
        if (Number.isFinite(index) && index >= 0 && index < this.slides.length) {
          return index;
        }
      } catch (_error) {
        return 0;
      }

      return 0;
    }

    saveActiveSlideIndex() {
      if (!this.designMode || !this.slideStorageKey) return;

      const slide = this.slides[this.currentIndex];
      if (!slide) return;

      try {
        sessionStorage.setItem(
          this.slideStorageKey,
          JSON.stringify({
            index: this.currentIndex,
            blockId: this.getSlideBlockId(slide),
          })
        );
      } catch (_error) {
        return;
      }
    }

    measureHeader() {
      const header = document.getElementById('sticky-header');
      if (!header) return;
      const height = header.getBoundingClientRect().height;
      if (height > 0) {
        this.style.setProperty('--hero-header-offset', `${height}px`);
      }
    }

    setupArrowsMobile() {
      if (this.dataset.showArrowsMobile === 'true') {
        this.classList.add('hero-slider--arrows-mobile');
      }
    }

    setupDots() {
      if (!this.dotsContainer) return;

      this.dots = this.slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-slider__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute(
          'aria-label',
          (this.dataset.dotLabelTemplate || 'Slide @@').replace('@@', String(index + 1))
        );
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
        return dot;
      });
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.prev();
        if (event.key === 'ArrowRight') this.next();
      });
    }

    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              this.slides.forEach((slide, i) => {
                slide.classList.toggle('is-active', i === this.currentIndex);
              });
            }
          });
        },
        { threshold: 0.5 }
      );
      this.observer.observe(this);
    }

    getSlideDuration(index) {
      const slide = this.slides[index];
      const duration = parseInt(slide?.dataset.slideDuration, 10);
      return Number.isFinite(duration) ? duration : 7000;
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = window.setTimeout(() => {
        this.next();
      }, this.getSlideDuration(this.currentIndex));
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    syncSlideWidths() {
      if (!this.viewport || !this.track || this.slides.length === 0) return;

      const slideWidth = this.viewport.offsetWidth;
      if (slideWidth <= 0) return;

      Array.from(this.track.children).forEach((wrapper) => {
        wrapper.style.flex = `0 0 ${slideWidth}px`;
        wrapper.style.width = `${slideWidth}px`;
      });

      this.slides.forEach((slide) => {
        slide.style.width = `${slideWidth}px`;
      });
    }

    updateTransform(animate = true) {
      if (!this.track || !this.viewport) return;

      const slideWidth = this.viewport.offsetWidth;
      const offset = this.currentIndex * slideWidth * -1;

      if (!animate || this.reducedMotion || this.editorNoAnimations) {
        this.track.style.transition = 'none';
      } else {
        this.track.style.transition = '';
      }

      this.track.style.transform = `translateX(${offset}px)`;
    }

    goTo(index, animate = true) {
      if (this.slides.length === 0) return;

      this.currentIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      const targetSlide = this.slides[this.currentIndex];

      this.syncSlideWidths();
      this.measureContentRef(targetSlide);
      this.updateTransform(animate);

      this.slides.forEach((slide, i) => {
        const isActive = i === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        if (!isActive) {
          this.clearEntryFreeze(slide);
          slide.querySelectorAll('.hero-layer').forEach((layer) => {
            layer.style.animation = 'none';
            layer.offsetHeight;
            layer.style.animation = '';
          });
        }
      });

      this.scheduleEntryFreezeClear(targetSlide);

      this.dots?.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.currentIndex);
        dot.setAttribute('aria-selected', i === this.currentIndex ? 'true' : 'false');
      });

      this.saveActiveSlideIndex();

      if (!this.reducedMotion && this.autoplayEnabled) {
        this.startAutoplay();
      }
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-brands"] && !Shopify.designMode) return;
  try {
    
  const initBrandsGrid = (grid) => {
    const itemCount = Number.parseInt(grid.dataset.brandsCount, 10);

    if (!itemCount || Number.isNaN(itemCount)) {
      return;
    }

    const updateColumns = () => {
      const styles = getComputedStyle(grid);
      const maxItem = Number.parseFloat(styles.getPropertyValue('--brands-item-max')) || 150;
      const gap = Number.parseFloat(styles.getPropertyValue('--brands-gap')) || 50;
      const containerWidth = grid.clientWidth;
      const maxCols = Math.max(1, Math.floor((containerWidth + gap) / (maxItem + gap)));

      let columns = itemCount;

      if (itemCount > maxCols) {
        columns = maxCols;
        let bestImbalance = Number.POSITIVE_INFINITY;

        for (let columnCount = 2; columnCount <= maxCols; columnCount += 1) {
          const remainder = itemCount % columnCount;
          const imbalance = remainder === 0 ? 0 : columnCount - remainder;

          if (imbalance < bestImbalance || (imbalance === bestImbalance && columnCount > columns)) {
            bestImbalance = imbalance;
            columns = columnCount;
          }
        }
      }

      grid.style.setProperty('--brands-columns', String(columns));
    };

    updateColumns();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateColumns);
      return;
    }

    const observer = new ResizeObserver(updateColumns);
    observer.observe(grid);
  };

  document.querySelectorAll('[data-brands-grid]').forEach(initBrandsGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const reloadJudgeMeWidgets = () => {
      if (!window.jdgm) return;
      if (typeof window.jdgm.customizeReload === 'function') {
        window.jdgm.customizeReload();
      } else if (typeof window.jdgm.loadWidgets === 'function') {
        window.jdgm.loadWidgets();
      }
    };

    const activateProductTab = (wrapper, target) => {
      const tab = wrapper.querySelector(`[data-product-tab][data-target="${target}"]`);
      if (!tab) return false;

      const tabs = wrapper.querySelectorAll('[data-product-tab]');
      tabs.forEach((other) => {
        other.classList.toggle('is-active', other === tab);
        other.setAttribute('aria-selected', other === tab ? 'true' : 'false');
      });
      wrapper.querySelectorAll('[data-product-tab-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.productTabPanel !== target;
      });

      if (target === 'reviews') {
        reloadJudgeMeWidgets();
      }

      return true;
    };

    document.querySelectorAll('[data-product-tabs]').forEach((wrapper) => {
      const tabs = wrapper.querySelectorAll('[data-product-tab]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activateProductTab(wrapper, tab.dataset.target);
        });
      });
    });

    document.querySelectorAll('.product__rating.jdgm-preview-badge').forEach((badge) => {
      badge.addEventListener(
        'click',
        (event) => {
          const tabsWrapper = document.querySelector('[data-product-tabs]');
          const reviewsWidget = document.getElementById('judgeme_product_reviews');
          if (!tabsWrapper || !reviewsWidget) return;

          event.preventDefault();
          event.stopPropagation();

          activateProductTab(tabsWrapper, 'reviews');

          requestAnimationFrame(() => {
            const offset = 100;
            const top = reviewsWidget.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
          });
        },
        true
      );
    });

    const initProductRecommendations = () => {
      document.querySelectorAll('.product__recommendations[data-url]').forEach((block) => {
        if (!block.classList.contains('is-loading')) return;
        fetch(block.dataset.url)
          .then((response) => response.text())
          .then((markup) => {
            const html = document.createElement('div');
            html.innerHTML = markup;
            const rootSelector = block.dataset.recommendationsRoot || '.product-related-recommendations';
            const recommendations = html.querySelector(rootSelector);
            if (recommendations && recommendations.innerHTML.trim().length) {
              block.innerHTML = recommendations.innerHTML;
              block.classList.remove('is-loading');
              window.initProductRowSliders?.(block);
            } else {
              block.remove();
            }
          })
          .catch(() => block.remove());
      });
    };

    initProductRecommendations();
  })();

  } catch(e) { console.error(e); }
})();
})();
